import Column from "@/components/Column";

import PageHeader from "@/components/PageHeader";
import SEO from "@/components/SEO";
import ShortFlowLayout from "@/components/ShortFlow/ShortFlowLayout";
import Columns from "@/components/Columns";

import Button from "@/components/Button";
import ErrorText from "@/components/ErrorText";
import useShortFlowFinishOrder from "./hooks/useShortFlowFinishOrder";
import ForceChangePaymentMethodAlert from "@/components/ForceChangePaymentMethod";
import CreditCardPaymentFields, {
  creditCardDataSchema,
} from "@/components/CreditCard";
import Form from "@/components/Form";
import Text from "@/components/Text";
import { useActiveStore } from "@/store/activePages";
import UnauthorizedAlert from "@/components/UnauthorizedAlert";

const CREDITO = `Cartão de Crédito`;

export function ShortFlowFinishOrder() {
  const {
    errorCreateOrder,
    handleBackHome,
    showForceChangePaymentMethod,
    setShowForceChangePaymentMethod,
    setUserSaidThatDontWantToChange,
    method,
    payment,
    setFormPaymentIsValid,
    handleShortChangePaymentMethod,
    pageConfig,
    formPaymentIsValid,
    createExpressSaleOrder,
    isLoading,
    progressStep,
    showUnauthorizedAlert,
    setShowUnauthorizedAlert,
  } = useShortFlowFinishOrder();
  const removePage = useActiveStore((store) => store.removePage);

  return (
    <ShortFlowLayout>
      <SEO
        title="Finalizando seu pedido"
        description="Aguarde enquanto finalizamos seu pedido."
      />

      {showForceChangePaymentMethod && (
        <ForceChangePaymentMethodAlert
          setShowForceChangePaymentMethod={setShowForceChangePaymentMethod}
          setUserSaidThatDontWantToChange={setUserSaidThatDontWantToChange}
          changeMethod={handleShortChangePaymentMethod}
          method={method}
        />
      )}

      {showUnauthorizedAlert && (
        <UnauthorizedAlert
          setShowUnauthorizedAlert={setShowUnauthorizedAlert}
        />
      )}

      {payment?.value === CREDITO && (
        <>
          <Column size={12} className="pb-6">
            <Text
              kind="blue"
              size="base"
              className="pt-2 font-bold"
              data-ic-title="sec-omega-comunicacao"
            >
              Estamos quase lá!
            </Text>
          </Column>
          <Columns
            as={Form}
            onSubmit={createExpressSaleOrder}
            validationSchema={creditCardDataSchema}
            justifyContent="center"
            alignItems="start"
          >
            <CreditCardPaymentFields setFormIsValid={setFormPaymentIsValid} />

            <Column size={12}>
              <Button
                type="submit"
                large
                disabled={!formPaymentIsValid}
                helperText={
                  !formPaymentIsValid ? "todos os campos são obrigatórios" : ""
                }
                loading={isLoading}
              >
                {!formPaymentIsValid
                  ? "Preencha os campos para continuar"
                  : "Finalizar Pedido"}
              </Button>
            </Column>
            <Column size={12} className="mt-8">
              <Button
                type="button"
                kind="secondary"
                large
                onClick={() => removePage(pageConfig.route)}
                to={pageConfig.prevRoute}
                data-ic-trigger="sec-omega-voltar"
              >
                Voltar
              </Button>
            </Column>
          </Columns>
        </>
      )}

      {!errorCreateOrder && payment?.value !== CREDITO && (
        <>
          <Column size={12} className="mt-10  flex justify-center  pb-8">
            <PageHeader
              title="Aguarde enquanto finalizamos seu pedido."
              dataIcTitle="sec-omega-comunicacao"
            />
          </Column>

          <Column size={12} className="flex  justify-center">
            <svg
              className="text-blue h-30 -ml-1 mr-3 w-20 animate-spin"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="#01479A"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="#01479A"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          </Column>

          {progressStep && (
            <Column size={12} className="mt-4 flex justify-center">
              <Text kind="blue" size="sm">
                {progressStep}
              </Text>
            </Column>
          )}
        </>
      )}

      {errorCreateOrder && payment?.value !== CREDITO && (
        <Column
          size={12}
          className="mt-4 flex h-full  flex-1 flex-col items-center justify-center gap-4"
        >
          <ErrorText id="errorSale">
            Erro ao tentar efetuar o pedido, tente novamente mais tarde.
          </ErrorText>

          <Button kind="secondary" type="button" onClick={handleBackHome}>
            Retornar para o ínicio
          </Button>
        </Column>
      )}
    </ShortFlowLayout>
  );
}
export default ShortFlowFinishOrder;
